import axios, { AxiosInstance } from 'axios'
import { getAccessToken } from './oidc'

export const externalClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_CORE_EXTERNAL_API_URL,
  headers: {
    'Authorization': `Bearer ${getAccessToken()}`,
  },
})
